import React from 'react';
import existingModelIcon from '../assets/existing-model.png';
import customModelIcon from '../assets/custom-model.png';

interface ApproachProps {
  onBack: () => void;
  onSelectExistingModel: () => void;
  onTrainCustomModel: () => void;
}

export const Approach: React.FC<ApproachProps> = ({
  onBack,
  onSelectExistingModel,
  onTrainCustomModel
}) => {
  return (
    <div className="wizard-step-container">
      <div className="wizard-step-header">
        <button className="back-button" onClick={onBack}>
          <span className="back-arrow">←</span> Back
        </button>
        <h1>Choose Your Approach</h1>
      </div>

      <p className="approach-description">
        Choose from pre-trained models or use your data to train custom models. Get ranked parameter
        recommendations in seconds, reducing simulation trial-and-error and improving design efficiency.
      </p>

      <div className="approach-options">
        <div className="option-card active-option">
          <div className="option-card-content" onClick={onSelectExistingModel}>
            <div className="option-icon">
              <img src={existingModelIcon} alt="Use Existing Model" />
            </div>
            <div className="option-text">
              <h3>Use Existing Model</h3>
              <p>Select from your trained AI models.</p>
            </div>
          </div>
        </div>

        <div className="option-card active-option">
          <div className="option-card-content" onClick={onTrainCustomModel}>
            <div className="option-icon">
              <img src={customModelIcon} alt="Train Custom Model" />
            </div>
            <div className="option-text">
              <h3>Train New Model</h3>
              <p>Create a new AI model using your own simulation data and algorithm preferences</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


